export const courses = [
  {
    id: 1,
    title: "Mastering Human Connections",
    description: "Learn the art of building meaningful relationships and creating lasting connections in both personal and professional settings.",
    price: 599,
    duration: "8 weeks",
    level: "Intermediate",
    instructor: "Hilal",
    image: "/api/placeholder/400/300",
    modules: [
      "Understanding Human Psychology",
      "Building Trust and Rapport",
      "Active Listening Techniques",
      "Non-verbal Communication",
      "Creating Emotional Bonds",
      "Maintaining Long-term Relationships",
      "Networking Strategies",
      "Conflict Resolution"
    ],
    features: [
      "8 comprehensive modules",
      "Interactive exercises",
      "Real-world case studies",
      "Lifetime access",
      "Certificate of completion",
      "Community support"
    ]
  },
  {
    id: 2,
    title: "The Communication Blueprint",
    description: "Master the fundamental principles of effective communication and transform how you connect with others.",
    price: 499,
    duration: "6 weeks",
    level: "Beginner",
    instructor: "Hilal",
    image: "/api/placeholder/400/300",
    modules: [
      "Communication Fundamentals",
      "Message Structure and Clarity",
      "Audience Analysis",
      "Verbal Communication Skills",
      "Written Communication",
      "Presentation Techniques"
    ],
    features: [
      "6 detailed modules",
      "Practical exercises",
      "Video demonstrations",
      "Lifetime access",
      "Certificate of completion",
      "Email support"
    ]
  },
  {
    id: 3,
    title: "Emotional Intelligence in Action",
    description: "Develop your emotional intelligence to better understand yourself and others, leading to improved relationships and success.",
    price: 799,
    duration: "10 weeks",
    level: "Advanced",
    instructor: "Hilal",
    image: "/api/placeholder/400/300",
    modules: [
      "Self-Awareness Development",
      "Emotional Regulation",
      "Empathy and Understanding",
      "Social Skills Enhancement",
      "Motivation and Drive",
      "Leadership Through EI",
      "Team Dynamics",
      "Personal Growth Strategies",
      "EI in Professional Settings",
      "Measuring Your Progress"
    ],
    features: [
      "10 comprehensive modules",
      "EI assessment tools",
      "Personal development exercises",
      "Lifetime access",
      "Certificate of completion",
      "1-on-1 coaching session"
    ]
  },
  {
    id: 4,
    title: "Conflict to Connection",
    description: "Transform conflicts into opportunities for deeper understanding and stronger relationships.",
    price: 699,
    duration: "7 weeks",
    level: "Intermediate",
    instructor: "Hilal",
    image: "/api/placeholder/400/300",
    modules: [
      "Understanding Conflict Dynamics",
      "Communication During Conflict",
      "De-escalation Techniques",
      "Finding Common Ground",
      "Building Bridges",
      "Preventing Future Conflicts",
      "Mediation Skills"
    ],
    features: [
      "7 practical modules",
      "Role-playing exercises",
      "Conflict resolution toolkit",
      "Lifetime access",
      "Certificate of completion",
      "Group discussion sessions"
    ]
  },
  {
    id: 5,
    title: "Authentic Leadership & Influence",
    description: "Develop authentic leadership skills and learn to influence others positively through genuine connection.",
    price: 899,
    duration: "9 weeks",
    level: "Advanced",
    instructor: "Hilal",
    image: "/api/placeholder/400/300",
    modules: [
      "Authentic Leadership Principles",
      "Building Trust and Credibility",
      "Influence Without Authority",
      "Leading by Example",
      "Team Building and Motivation",
      "Decision Making and Accountability",
      "Crisis Leadership",
      "Personal Brand Development",
      "Legacy and Impact"
    ],
    features: [
      "9 advanced modules",
      "Leadership assessment",
      "Case study analysis",
      "Lifetime access",
      "Certificate of completion",
      "Executive coaching session"
    ]
  },
  {
    id: 6,
    title: "Building Confidence Through Communication",
    description: "Boost your confidence by mastering communication skills that help you express yourself clearly and assertively.",
    price: 549,
    duration: "5 weeks",
    level: "Beginner",
    instructor: "Hilal",
    image: "/api/placeholder/400/300",
    modules: [
      "Overcoming Communication Anxiety",
      "Voice and Body Language",
      "Assertive Communication",
      "Public Speaking Basics",
      "Building Self-Confidence"
    ],
    features: [
      "5 focused modules",
      "Confidence-building exercises",
      "Video practice sessions",
      "Lifetime access",
      "Certificate of completion",
      "Peer support group"
    ]
  }
];

export const getCourseById = (id) => {
  return courses.find(course => course.id === parseInt(id));
};
